import blog20Main from "@/assets/images/blogs/20/main.jpg";
import blog20Risk from "@/assets/images/blogs/20/risk-stats.png";
import blog20Inheritance from "@/assets/images/blogs/20/inheritance.png";
import blog20Mammogram from "@/assets/images/blogs/20/mammogram.png";
import blog20Quote from "@/assets/images/blogs/20/sandra-quote.jpg";
import { BLOG_TAGS } from "../BlogTags";
import BlogContent, { BlogContentWithSlug } from "../BlogContent";
import { addSlug } from "@/utils/addSlug";
import ROUTES from "@/data/Routes";
import { ActionLink } from "@/components/UI/Buttons";

const BRCA_MUTATIONS_WITHOUT_SLUG: BlogContent = {
  id: 20,
  label:
    "BRCA1 ir BRCA2 genų mutacijos: ką iš tikrųjų reiškia turėti paveldimą riziką?",
  description:
    "Nemaža dalis svarbiausios informacijos apie mūsų sveikatą slypi genuose. Jos neatskleis nei savijauta, nei kraujo tyrimai, nei kasmetinė echoskopija. Apie tai kalbame ne tam, kad gąsdintume, o todėl, kad savo praktikoje BRCA1 ir BRCA2 genų mutacijų aptinkame vis dažniau. Įprastų profilaktinių priemonių ne visada pakanka, todėl kartais liga pastebima vėliau, nei norėtųsi. Gera žinia ta, kad tokias mutacijas galima aptikti dar tada, kai žmogus jaučiasi visiškai sveikas, taip užbėgant įvykiams už akių. Todėl šiame straipsnyje ramiai ir be žargono paaiškiname, kas tai yra, ką ši mutacija keičia ir kodėl ji dažnai lieka nepastebėta.",
  descriptionInner:
    "Nemaža dalis svarbiausios informacijos apie mūsų sveikatą slypi genuose. Jos neatskleis nei savijauta, nei kraujo tyrimai, nei kasmetinė echoskopija.",
  img_src: blog20Main,
  alt: "BRCA1 ir BRCA2 genų mutacijos",
  tags: [BLOG_TAGS.GENETICS.label, BLOG_TAGS.GENOME.label],
  more_blogs_ids: [19, 12, 1],
  innerData: [
    {
      id: 1,
      label: "Genas nėra priešas",
      description: [
        "BRCA1 ir BRCA2 turi kiekvienas iš mūsų. Tai naudingi, naviką slopinantys genai, kurių užduotis yra taisyti pažeistą DNR ir neleisti ląstelėms daugintis nekontroliuojamai. Kol jie veikia, jie mus saugo.",
        "Problema atsiranda tuomet, kai viename iš šių genų įvyksta mutacija. Tokiu atveju „taisymo mechanizmas\" nustoja veikti taip, kaip turėtų, ir laikui bėgant rizika susirgti tam tikrais vėžiais išauga. Pavojų kelia ne genas, o jo mutacija. Ir ją gali turėti visiškai sveikas, jokių simptomų nejaučiantis žmogus.",
      ],
    },
    {
      id: 2,
      label: "Ką konkrečiai keičia mutacija?",
      description: [
        "Skaičiai geriausiai parodo, kodėl ši tema verta dėmesio.",
        "Vidutinės moters rizika per gyvenimą susirgti krūties vėžiu yra apie 12-13 %. Moteriai, turinčiai BRCA1 mutaciją, ši rizika išauga iki 55-72 %. Kiaušidžių vėžio atveju skirtumas dar ryškesnis: bendroje populiacijoje rizika siekia apie 2 %, o su BRCA1 mutacija - 39-44 %.",
        <img
          src={blog20Risk}
          alt="BRCA rizikos statistika"
          className="mb-8"
        />,
        "Be to, su šia mutacija susiję vėžiai linkę pasireikšti anksčiau nei įprastai. Dažnai dar iki 40 metų. Tuo metu, kai profilaktiniai patikrinimai valstybinėse programose paprastai dar net neprasidėję.",
        "Vienas dalykas, kurį svarbu pabrėžti: teigiamas tyrimo rezultatas dar nėra diagnozė. Tai padidėjusi rizika, o ne neišvengiamybė. Ir būtent todėl, kad tai yra rizika, ją galima valdyti, jei apie ją žinome laiku.",
      ],
    },
    {
      id: 3,
      label: "BRCA mutacijos aktualios ne tik moterims",
      description: [
        "Apie BRCA dažniausiai kalbama krūties ir kiaušidžių vėžio kontekste, tačiau paveldima rizika platesnė. BRCA2 mutacijos siejamos ir su kasos vėžiu.",
        "Vyrams jos taip pat aktualios. BRCA2 mutaciją turintys vyrai turi kelis kartus didesnę prostatos vėžio riziką, o pats vėžys neretai būna agresyvesnis.",
      ],
    },
    {
      id: 4,
      label: "Kodėl paveldima rizika taip dažnai lieka nepastebėta?",
      description: [
        "BRCA1 ir BRCA2 yra ne lytinėse, o įprastose chromosomose. Tai reiškia, kad mutacija paveldima vienodai tiek iš mamos, tiek iš tėčio, ir kiekvienas vaikas turi 50 % tikimybę ją paveldėti.",
        <img
          src={blog20Inheritance}
          alt="BRCA geno mutacijos paveldėjimas"
          className="mb-8"
        />,
        "Būtent dėl paveldėjimo iš tėvo pusės rizika dažnai „pasislepia\". Jei tėvo giminėje mažai moterų, šeimos istorijoje gali visai nebūti matomų krūties ar kiaušidžių vėžio atvejų, nors mutacija ramiai keliauja iš kartos į kartą. Šeimos istorijos nebuvimas negarantuoja, kad mutacijos nėra.",
        "Ir tai nėra retas atvejis. Skaičiuojama, kad patogeninį BRCA variantą turi maždaug 1 iš 400 žmonių.",
      ],
    },
    {
      id: 5,
      label: "Kartais profilaktinių patikrinimų gali nepakakti",
      description: [
        "Reguliarūs patikrinimai yra be galo svarbūs ir vertingi, tačiau tam tikrais atvejais jų gali nepakakti.",
        "Įprasta mamografija praleidžia maždaug 1 iš 8 krūties vėžio atvejų. Esant tankiam krūtų audiniui, tyrimo jautrumas sumažėja. Tankus krūties audinys gali maskuoti naviką, todėl jį sunkiau pastebėti.",
        <img
          src={blog20Mammogram}
          alt="Tankaus ir netankaus krūties audinio mamogramos palyginimas"
          className="mb-8"
        />,
        "Tai nereiškia, kad tyrimai „neveikia\", dauguma vėžio atvejų šiais tyrimais yra pastebimi. Tačiau žinant, jog BRCA mutacija yra, atliekamas krūtų MRT tyrimas, sudaromas aktyvesnis profilaktinių patikrinimų planas.",
      ],
    },
    {
      id: 6,
      label: "Ką duoda genetinis tyrimas?",
      description: [
        "Genetinis tyrimas suteikia aiškumą ir atsako į klausimą, ar esame didesnės rizikos grupėje ir ar verta imtis aktyvesnių veiksmų.",
        "Jeigu patogeninis variantas randamas:",
        <ul className="text-dark list-disc space-y-1 pl-5 font-light md:text-lg">
          <li>
            stebėsena pradedama anksčiau, nei numato bendros profilaktinės
            programos,
          </li>
          <li>
            į planą įtraukiami jautresni tyrimai, pavyzdžiui, krūtų MRT, kuri
            gali aptikti tai, ką mamografija ar echoskopija gali praleisti,
          </li>
          <li>aptariamos individualios riziką mažinančios priemonės,</li>
          <li>
            įvertinama, kuriems šeimos nariams tyrimas taip pat gali būti
            aktualus.
          </li>
        </ul>,
        "Svarbu suprasti, kad genetinio tyrimo rezultatas vertinamas kartu su asmenine ir šeimos ligų istorija, o išvadas paaiškina gydytojas genetikas. Būtent ši gydytojo interpretacija ir yra tikroji vertė.",
      ],
    },
    {
      id: 7,
      label: "",
      description: [
        "Telomeros klinikoje šią konsultaciją teikia gydytoja genetikė Sandra Tumėnė, kuri teigia:",
        <img
          src={blog20Quote}
          alt="Gydytoja genetikė Sandra Tumėnė"
          className="mb-8"
        />,
      ],
    },
    {
      id: 8,
      labelClass: "text-center",
      label: "Norite pasikonsultuoti dėl šio tyrimo?",
      description: [
        <div className="mt-4 flex justify-center">
          <ActionLink
            to={ROUTES.CONSULTATION}
            variant="dark"
            className="w-full md:w-auto"
          >
            Registruokitės nemokamai konsultacijai
          </ActionLink>
        </div>,
        <p className="text-dark mt-8 text-center text-sm font-light md:text-base">
          Šis straipsnis yra edukacinio pobūdžio ir nepakeičia individualios
          gydytojo konsultacijos. Sprendimai dėl tyrimų ir sveikatos priežiūros
          priimami įvertinus asmeninę situaciją su kvalifikuotu specialistu.
        </p>,
      ],
    },
  ],
};

export const BRCA_MUTATIONS: BlogContentWithSlug = addSlug(
  BRCA_MUTATIONS_WITHOUT_SLUG,
);

export default BRCA_MUTATIONS;
